import { useEffect, useState } from "react";
import { ArrowRight, CalendarRange, LockKeyhole } from "lucide-react";
import { EventCard } from "@/components/events/EventCard";
import { InstagramFeed } from "@/components/social/InstagramFeed";
import { eventsApi } from "@/services/eventsApi";
import "@/events.css";

const tabs = ["upcoming", "ongoing", "past"];

export default function Events({ onQuote }) {
  const [events, setEvents] = useState([]);
  const [active, setActive] = useState("upcoming");
  const [state, setState] = useState("loading");
  useEffect(() => {
    eventsApi.get("/events").then(({ data }) => {
      setEvents(data); setState("ready");
      const hash = window.location.hash.slice(1);
      const shared = hash && data.find(item => item.event_id === hash);
      if (shared) {
        setActive(shared.status);
        setTimeout(() => document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "start" }), 350);
      }
    }).catch(() => setState("error"));
  }, []);
  const visible = events.filter(event => event.status === active);
  return (
    <main data-testid="events-page">
      <section className="events-hero" data-testid="events-hero-section">
        <img src="/media/presentation/page-08-image-03.webp" alt="MADMINUTE live motorsport event" />
        <div className="events-hero-shade"/>
        <div className="events-hero-copy"><p className="eyebrow">MADMINUTE / Live calendar</p><h1>WHERE THE<br/><span>ACTION HAPPENS.</span></h1><p>Upcoming programs, live projects, and field experiences—published with official details and brochures.</p><button className="button button-primary" onClick={() => onQuote("Motorsports Management")} data-testid="events-enquiry-button">Plan an event <ArrowRight/></button></div>
      </section>
      <section className="events-listing section-pad" data-testid="events-listing-section">
        <div className="section-heading-row"><div><p className="eyebrow">Event updates</p><h2>THE LIVE BOARD</h2></div><p>Choose a category to explore schedules, locations, project details, and official brochures.</p></div>
        <div className="event-tabs" role="tablist" aria-label="Event status">
          {tabs.map(tab => <button key={tab} role="tab" aria-selected={active === tab} className={active === tab ? "is-active" : ""} onClick={() => setActive(tab)} data-testid={`events-${tab}-tab`}>{tab}<span>{events.filter(item => item.status === tab).length}</span></button>)}
        </div>
        {state === "loading" && <div className="events-message" data-testid="events-loading-message"><CalendarRange/> Loading event updates...</div>}
        {state === "error" && <div className="events-message is-error" data-testid="events-error-message">Event updates are temporarily unavailable. Please contact our team for the latest schedule.</div>}
        {state === "ready" && visible.length === 0 && <div className="events-message" data-testid="events-empty-message"><CalendarRange/><h3>NO {active.toUpperCase()} EVENTS PUBLISHED YET.</h3><p>New programs and project updates will appear here as soon as they are confirmed.</p></div>}
        <div className="events-grid">{visible.map((event, index) => <EventCard key={event.event_id} event={event} index={index}/>)}</div>
        <a href="/events/manage" className="events-manage-link" data-testid="events-manage-link"><LockKeyhole/> Manage event updates</a>
      </section>
      <InstagramFeed />
    </main>
  );
}
